import { getStoreState } from 'config/store'
import { getCampaignFromEmbedById } from 'modules/embed/utils'
import { isEmpty, path, pathOr } from 'ramda'
import { isMobileDevice } from 'shared/src/utils/platform'
import { Embed, EmbedCampaign, WidgetPositionType } from 'types/embed'
import { WidgetColorMode } from 'types/theme'
import { isNilOrEmpty } from 'utils'

export const getEmbed = (state): Embed => {
  return path(['embed'],state)
}

export const getEmbedId = (state): string => {
  return path(['embed', 'id'], state)
}

export const getEmbedPathOr = (defaultValue: any, path:string[]) => {
  const { embed = {} } = getStoreState()
  return pathOr(defaultValue, path, embed)
}

export const getEmbedConfiguration = (state) => {
  return path(['embed','configuration'],state)
}

export const getCampaignAttributeById = <P extends keyof EmbedCampaign> (campaignId: number, attribute: string, defaultVal?: any) : EmbedCampaign[P] => {
  const campaign = getCampaignFromEmbedById(campaignId)

  if (!campaign) {
    return defaultVal
  }

  return pathOr(defaultVal, ['attributes', attribute], campaign)
}

export const getPardotVisitorId = (state): string => path(['embed', 'configuration', 'integrations', 'pardotId'], state)

export const getInboxId = (state): number => pathOr(null,['embed','configuration','inboxId'], state)

export const getInboxIdOverride = (state): number => path(['embed', 'overrides', 'inboxId'], state)

export const getEmbedThemeValueOrDefault = (state, propertyKey, defaultValue = undefined) => pathOr(defaultValue, ['embed', 'configuration', 'theme', propertyKey], state)

export const getEmbedConfigurationValueOrDefault = (state, propertyKey, defaultValue = undefined) => pathOr(defaultValue, ['embed', 'configuration', propertyKey], state)

export const getIsInLandingPageMode = (state) => !isEmpty(pathOr({}, ['embed', 'configuration', 'landingPageConfig'], state))

export const getLandingPageConfigurationValueOrDefault = (state, propertyKey, defaultValue) => pathOr(defaultValue, ['embed', 'configuration', 'landingPageConfig', propertyKey], state)

export const getFirstGradientLandingPageColor = (state) => getLandingPageConfigurationValueOrDefault(state, 'firstGradientColor', 'F55C5C')

export const getSecondGradientLandingPageColor = (state) => getLandingPageConfigurationValueOrDefault(state, 'secondGradientColor', 'C755D5')

export const getWidgetColorMode = (state): WidgetColorMode => getLandingPageConfigurationValueOrDefault(state, 'colorMode', WidgetColorMode.DEFAULT)

export const getEndUserAllowedToSendGif = (state) => pathOr(true,['embed','configuration','theme','allowEndUserToSendGif'],state)

export const getVerticalOffset = (state): number => {
  return getOffset('bottom',state)
}

export const getHorizontalOffset = (state): number => {
  return getOffset('horizontal',state)
}

const getOffset = (type,state): number =>{
  const device = isMobileDevice() ? "mobile" : "desktop"
  const positionType = pathOr(
    WidgetPositionType.DEFAULT,
    ["embed", "configuration", "theme", "widgetIconPosition", device, "type"],
    state
  )

  if (positionType === WidgetPositionType.DEFAULT){
    return undefined
  }

  const customPosition = state.embed.configuration.theme.widgetIconPosition[device].spacing
  return isNilOrEmpty(customPosition[type]) ? undefined : parseFloat(customPosition[type])
}
